'use client';

import { useBunja } from 'bunja/react';
import { useContext } from 'react';

import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import segment from '@flipster/utils/segment';
import { CompetitionsEvent } from '@flipster/utils/segment/events/competitions';

import ContentfulRichText from '../../shared/contentful-rich-text';
import { Accordion } from '../../shared/faq-accordion';
import { MaxWidthLayout } from './component/layout';
import { CompetitionIdContext, competitionBunja } from './state';

export const Faq = () => {
  const id = useContext(CompetitionIdContext);
  const { competitionContentful } = useBunja(competitionBunja);

  const faqs = competitionContentful?.faqCollection?.items.filter(Boolean);

  if (!faqs?.length) return null;

  return (
    <MaxWidthLayout css={{ pt: { base: 24, tablet: 64 }, pb: { base: 48, tablet: 64 } }}>
      <h2
        className={css({
          textStyle: 'Display/XL',
          color: 'content.default.level-5',
          textAlign: 'center',
        })}
      >
        <FormattedMessage id='Competition.r251215.Frequently_asked_questions' />
      </h2>
      <Accordion.Root headingLevel={3} css={{ mt: { base: 32, tablet: 40 } }}>
        {faqs.map((faq, index) => {
          if (!faq) return null;
          return (
            <Accordion.Item key={faq.sys.id}>
              <Accordion.Header
                index={index + 1}
                onExpanded={() =>
                  segment.track(CompetitionsEvent.CompetitionTradingFaqListClick, {
                    competition_id: id,
                    list_order: index,
                  })
                }
              >
                {faq.title}
              </Accordion.Header>
              <Accordion.Panel>
                {faq.description && <ContentfulRichText richTextDocument={faq.description} />}
              </Accordion.Panel>
            </Accordion.Item>
          );
        })}
      </Accordion.Root>
    </MaxWidthLayout>
  );
};
